const appVersion = "2026.10.8";
export default appVersion;
//please do not edit the lines above